import React, { useState } from 'react';

import Tooltip from 'components/Tooltips/FloaterInf';

import { Img, Text, Container } from './styles';

interface Props {
  idTooltip?: string;
  text?: string;
  imgTooltip?: string;
}

const SimpleTooltip = ({ text, imgTooltip, idTooltip }: Props) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const renderContent = () => <Text>{text}</Text>;

  return (
    <Container>
      <Img
        src={imgTooltip || '/corporate/images/advice-2.svg'}
        id={idTooltip || 'target'}
        onClick={() => setShowTooltip(true)}
        alt=""
      />
      {showTooltip && (
        <Tooltip
          noCloseBtn
          onClose={() => setShowTooltip(false)}
          target={idTooltip || 'target'}
          content={renderContent()}
        />
      )}
    </Container>
  );
};

export default SimpleTooltip;
